import { cn } from '@/lib/utils'

export type HealthStatus = 'online' | 'warning' | 'error' | 'offline'

const tone: Record<HealthStatus, string> = {
  online: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-danger',
  offline: 'bg-offline',
}

export function StatusDot({ status, pulse = false, className }: { status: HealthStatus; pulse?: boolean; className?: string }) {
  return (
    <span className={cn('relative inline-flex size-2', className)} aria-hidden>
      {pulse && status !== 'offline' && <span className={cn('absolute inline-flex size-full animate-ping rounded-full opacity-60', tone[status])} />}
      <span className={cn('relative inline-flex size-2 rounded-full', tone[status])} />
    </span>
  )
}
